import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Reveal } from "@/components/effects/Reveal";
import { Dragonfly } from "@/components/effects/Dragonfly";
import { T } from "@/context/SiteContent";

export const FAQ = ({ faqs }) => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section id="faq" className="section relative">
      <div className="section-tint" />
      <div className="container grid md:grid-cols-[1fr_1.4fr] gap-14">
        <Reveal>
          <p className="eyebrow mb-4"><T k="faq.eyebrow" fallback="Common questions" /></p>
          <h2 className="font-serif text-5xl md:text-6xl tracking-tight leading-none"><T k="faq.headline" fallback="Answered by the willow." /></h2>
          <p className="mt-6 text-[#B9C8D5]"><T k="faq.contact_line" fallback="Still curious?" /> <a href="#contact" className="text-[#FFD166] underline underline-offset-4"><T k="faq.contact_cta" fallback="Ask us anything" /></a>.</p>
          <div className="mt-8 opacity-80"><Dragonfly size={70} /></div>
        </Reveal>
        <div>
          {faqs.map((f, i) => (
            <div key={f.q} className="faq-item" data-testid={`faq-${i}`}>
              <div className="faq-q" onClick={() => setOpenIdx(openIdx === i ? -1 : i)}>
                <span>{f.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#FFD166] transition-transform ${openIdx === i ? "rotate-180" : ""}`} />
              </div>
              <AnimatePresence>
                {openIdx === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}>
                    <div className="faq-a">{f.a}</div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
